import * as React from 'react';
import { Helmet } from 'react-helmet';
import Card from '../components/Card/Card';
import Cover from '../components/Cover/Cover';
import Intro from '../components/Intro/Intro';
import Main from '../components/Main/Main';
import Case from '../Entities/Case';
import ContentfulAsset from '../Entities/Contentful/ContentfulAsset';
import ContentfulPage from '../Entities/Contentful/ContentfulPage';
import Site from '../Entities/Site';
import getMetaDescription from '../utils/getMetaDescription';
import mapCase from '../utils/mapCase';

interface Props {
  data: {
    site: Site;
    contentfulPage: ContentfulPage;
    contentfulAsset: ContentfulAsset;
  };
}

export interface State {
  coverHeight: number;
}

export default class extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      coverHeight: 0
    };

    this.handleCoverHeight = this.handleCoverHeight.bind(this);
  }

  public render() {
    const data = this.props.data;
    const cases: Case[] = (data.contentfulPage.cases as any).map((x: any) => mapCase(x));
    return (
      <div>
        <Helmet
          title="Elesthorp"
          meta={[
            {
              content: getMetaDescription(data.contentfulPage.description.childMarkdownRemark.html),
              name: 'description'
            }
          ]}
        />
        <Cover image={data.contentfulPage.media.sizes} getHeight={this.handleCoverHeight} />
        <Main coverHeight={this.state.coverHeight}>
          <Intro
            title={data.contentfulPage.title}
            image={data.contentfulAsset.file ? { src: data.contentfulAsset.file.url } : undefined}
            description={data.contentfulPage.description.childMarkdownRemark.html}
          />
          {cases.map((c: Case) => (
            <Card id={c.id} key={c.id} title={c.title} description={c.description} image={c.image} />
          ))}
        </Main>
      </div>
    );
  }

  private handleCoverHeight(height: number) {
    this.setState({ coverHeight: height });
  }
}

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
      }
    }
    contentfulAsset(title: { eq: "Elesthorp logo gray" }) {
      file {
        fileName
        url
      }
    }
    contentfulPage(title: { eq: "Startsida" }) {
      id
      title
      description {
        childMarkdownRemark {
          html
        }
      }
      media {
        file {
          fileName
          url
        }
        sizes(maxWidth: 1400, quality: 100) {
          src
          srcSet
          aspectRatio
          sizes
        }
      }
      cases {
        id
        title
        description {
          childMarkdownRemark {
            html
          }
        }
        media {
          file {
            fileName
            url
          }
          sizes(maxWidth: 800, quality: 100) {
            src
            srcSet
            aspectRatio
            sizes
          }
        }
        stories {
          id
          title
          description {
            childMarkdownRemark {
              html
            }
          }
          media {
            file {
              fileName
              url
            }
            sizes(maxHeight: 800, quality: 100) {
              src
              srcSet
              aspectRatio
              sizes
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.tsx